<div class="form-header-content ps-3 pe-3 bg-light">
  <div class="form-header-text">
    <ng-content></ng-content>
  </div>
  <div class="button-container">
    <button type="button" class="btn-close" (click)="onClickCloseButton($event)"></button>
  </div>
</div>
